import React from 'react';
import {
	InputWrapper,
	NiceFormGroup,
	RangeInputWrapper,
	RangeWrapper,
} from './Components.styles';
import Slider from 'rc-slider';
import { ApInput, ApIcon, colors } from '@alixpartners/ui-components';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';

const SliderInput = ({ label, onChange, name, value, instructions }) => {
	return (
		<NiceFormGroup>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<label style={{ lineHeight: '1.3' }}>{label}</label>
				{instructions && (
					<Tooltip
						position="bottom"
						animation="fade"
						arrow
						html={<TooltipContent>{instructions}</TooltipContent>}
						trigger="mouseenter"
						style={{ marginBottom: '4px', marginLeft: '5px' }}
					>
						<ApIcon
							iconName="info"
							iconSize="22px"
							outlined={true}
							iconColor={colors.green300}
						/>
					</Tooltip>
				)}
			</div>
			<RangeInputWrapper>
				<InputWrapper>
					<ApInput
						symbol={'%'}
						value={value}
						type="text"
						onChange={e => {
							let obj = {
								target: {
									value: e > 100 ? 100 : e,
									name: name,
									type: 'slider',
									isNumber: true,
								},
							};
							onChange(obj);
						}}
					/>
				</InputWrapper>
				<RangeWrapper>
					<Slider
						min={0}
						max={100}
						defaultValue={0}
						value={value}
						step={10}
						onChange={e => {
							let obj = {
								target: {
									value: e,
									name: name,
									type: 'slider',
								},
							};
							onChange(obj);
						}}
					/>
				</RangeWrapper>
			</RangeInputWrapper>
		</NiceFormGroup>
	);
};

export default SliderInput;
